export enum BLOCKCHAIN_NETWORKS {
  POLYGON = "polygon",
  POLYGON_MUMBAI = "polygonMumbai",
}
